module.exports = __webpack_public_path__ + "assets/img/secondPrize.c0c461f8.png";